// extracted by mini-css-extract-plugin
module.exports = {"list":"why-voltaware_list__u2lQl"};